<ng-container *transloco="let t; read: TRANSLATION_SCOPE">
  <ng-container *ngIf="authFacade.showSuccessMessage$ | async; else showResetPasswordForm">
    <h3 class="text-center mb-4">
      {{ t('success.header') }}
    </h3>

    <rx-button buttonClass="primary" [routerLink]="addAbsolutePathPrefix(authRoutes.Login)" [flexible]="true">
      {{ t('success.button') }}
    </rx-button>
  </ng-container>
  <ng-template #showResetPasswordForm>
    <h3 class="text-center mb-4">{{ t('header') }}</h3>

    <rx-alert *ngIf="authFacade.error$ | async as error" type="danger" [message]="t('error.' + error)"></rx-alert>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
      <rx-input
        [label]="t('form.label.confirmationCode')"
        [help]="t('form.label.confirmationCodeHelp', { email })"
        formControlName="confirmationCode"
        *ngIf="!confirmationCode"
      >
        <div rx-error *ngIf="isFieldInvalid(form, 'confirmationCode', 'required')">
          {{ t('error.confirmationCodeMissing') }}
        </div>
      </rx-input>
      <rx-password-match-form
        [parentForm]="form"
        [passwordLabel]="t('label.password')"
        [passwordConfirmLabel]="t('label.passwordConfirm')"
        [passwordMissing]="t('error.passwordMissing')"
        [passwordNotEqual]="t('error.passwordNotEqual')"
        [passwordPattern]="t('error.passwordPattern')"
      ></rx-password-match-form>
      <rx-applications-password-policy />
      <rx-button type="submit" buttonClass="primary" [flexible]="true" [disabled]="authFacade.isLoading$ | async">
        <span *ngIf="(authFacade.isLoading$ | async) === false; else isLoading">{{ t('button.active') }}</span>
        <ng-template #isLoading>{{ t('button.loading') }}</ng-template>
      </rx-button>
    </form>
  </ng-template>
</ng-container>
